// Used internally in the component to distinguish between user/team ID's when using the combined list.
export const TEAM_ID_PREFIX = 'team-';
export const USER_ID_PREFIX = 'user-';
export const isTeamId = id => id.indexOf(TEAM_ID_PREFIX) === 0;
export const makeTeamIdForSelect = id => `${TEAM_ID_PREFIX}${id}`;
export const extractTeamIdFromSelect = teamOptionId => parseInt(teamOptionId.split(TEAM_ID_PREFIX)[1], 10);
export const isUserId = id => id.indexOf(USER_ID_PREFIX) === 0;
export const makeUserIdForSelect = id => `${USER_ID_PREFIX}${id}`;
export const extractUserIdFromSelect = userOptionId => parseInt(userOptionId.split(USER_ID_PREFIX)[1], 10);